
export function originalInterviewFilename(data={}){
 return String(data?.filename || data?.title || 'Untitled interview').trim();
}
// The editorial display label is independent of the original camera filename.
export function interviewDisplayName(data={}){
 const named=String(data?.displayName || data?.title || '').trim();
 return named || originalInterviewFilename(data).replace(/\.[a-z0-9]{1,8}$/i,'');
}
// Legacy renames were saved as title, newer renames also have displayName.
export function interviewAlias(data={}){
 const original=originalInterviewFilename(data);
 const base=original.replace(/\.[a-z0-9]{1,8}$/i,'');
 const preferred=String(data?.displayName || data?.title || '').trim();
 return preferred && preferred!==original && preferred!==base ? preferred : '';
}
export function storySourceDisplayName(row,saved){
 if(row?.data)return interviewDisplayName(row.data);
 return interviewDisplayName(saved);
}
export function updateStorySourceLabel(paper,id,label){
 if(!paper?.sources?.[id] || !label || paper.sources[id].title===label)return paper;
 return {...paper,sources:{...paper.sources,[id]:{...paper.sources[id],title:label,displayName:label}}};
}
